<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("Payment Gateway Refund") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                id="selectcinema"
                :disabled="isRoleID"
                :text="selectedCinema"
                class="w-100"
                name="selectcinema"
                variant="dropdown-curve"
              >
                <div class="px-2 pb-2">
                  <input
                    v-model="searchCinema"
                    :placeholder="$t('searchCinema')"
                    autofocus
                    class="form-control form-control-sm"
                    required
                    type="search"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:search="onSearchCinema($event.target.value)"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  href="#"
                  v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <!-- Transaction Date From-->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="fetchReservationDetail.from_date"
                  class="btn-clearDate"
                  v-on:click="clearDate(2)"
                >
                  ✖
                </button>
                <Datepicker
                  id="selectenddate_1"
                  ref="programaticOpen"
                  v-model="fetchReservationDetail.from_date"
                  v-validate="'required'"
                  :monday-first="true"
                  :typeable="true"
                  name="selectenddate_1"
                  @input="onchangeDate()"
                ></Datepicker>
                <label :class="fetchReservationDetail.from_date ? 'active' : ''"
                  >{{ $t("Reservation") }} {{ $t("fromdate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- Transaction Date To -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="fetchReservationDetail.to_date"
                  class="btn-clearDate"
                  v-on:click="clearDate('to_date')"
                >
                  ✖
                </button>
                <Datepicker
                  id="selectenddate_3"
                  ref="programaticOpen"
                  v-model="fetchReservationDetail.to_date"
                  v-validate="'required'"
                  :monday-first="true"
                  :typeable="true"
                  name="selectenddate_3"
                  @input="onchangeDate()"
                ></Datepicker>
                <label :class="fetchReservationDetail.to_date ? 'active' : ''"
                  >{{ $t("Reservation") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              :disabled="btenable"
              class="btn-blue-lg w-100"
              @click.prevent.stop="onGetTransactionList((isExcel = 'N'))"
            >
              {{ $tc("fetch") }} {{ $tc("report") }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <div class="d-flex justify-content-end align-items-center mb-4">
          <div class="w-50">
            <b-form-input
              v-model="searchReservations"
              v-debounce:800="onSearchReservation"
              placeholder="Search "
            ></b-form-input>
          </div>

          <div class="mx-3">
            <b-dropdown
              :text="filter_is_active_label"
              variant="dropdown-curve"
              class="ml-auto mr-3 filter-status-dropdown"
              style="min-width: 300px"
            >
              <!-- <b-dropdown-item @click="onChangeFilterIsActive('All')">
                All
              </b-dropdown-item> -->
              <b-dropdown-item
                @click="
                  onChangeFilterIsActive('Payment Success | Booking Success')
                "
              >
                Payment Success | Booking Success
              </b-dropdown-item>

              <b-dropdown-item
                @click="
                  onChangeFilterIsActive('Payment Success | Booking Failed')
                "
              >
                Payment Success | Booking Failed
              </b-dropdown-item>

              <b-dropdown-item @click="onChangeFilterIsActive('Pending')">
                Pending
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="d-flex"></div>
          <div class="d-flex align-items-center justify-content-end w-100">
            <div class="mx-2">
              <b-dropdown
                id="listview"
                class=""
                name="listview"
                variant="outline-blue"
              >
                <template v-slot:button-content>
                  {{ $tc("viewing") }}&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;Of&nbsp;
                  <strong>{{ rows }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  >{{ list.name }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div
            class="col-lg-6 col-xl-2 align-self-center mb-3 d-flex justify-content-end align-items-center p-0"
            v-if="reservationList.length"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <a
              target="_blank"
              @click="onGetTransactionList((isExcel = 'Y'))"
              title="Download as Excel"
              style="cursor: pointer"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
        <div
          class="swc-report"
          ref="exportable_table"
          :class="reservationList.length > 0 ? 'overflow_custom' : ''"
        >
          <table border="1" class="swc-report-table mb-3">
            <thead class="custom_sticky_header bg-lightgrey">
              <tr>
                <th>{{ $tc("Reservation ID") }}</th>
                <th>{{ $tc("Cinema Name") }}</th>
                <th>{{ $tc("Movie Name") }}</th>
                <th>{{ $tc("customer") }} {{ $tc("email") }}</th>
                <th>{{ $tc("customer") }} {{ $tc("Number") }}</th>
                <th>{{ $tc("Booking") }} {{ $tc("Source") }}</th>
                <th>
                  {{ $tc("reservation") }} {{ $tc("date") }} & {{ $tc("time") }}
                </th>
                <th>
                  {{ $tc("show") }} {{ $tc("booking") }} {{ $tc("date") }} &
                  {{ $tc("time") }}
                </th>
                <th>{{ $tc("Booking Code") }}</th>
                <th>{{ $tc("Seat Name") }}</th>
                <th>{{ "Pickup Code" }}</th>
                <th>{{ $tc("Payment Type") }}</th>
                <th>{{ $tc("Payment Status") }}</th>
                <th>{{ $tc("Booking Status") }}</th>

                <th>{{ "Card" }}</th>
                <th>{{ "Card Number" }}</th>
                <th>{{ "Name on Card" }}</th>
                <th>{{ "Authorization Code" }}</th>
                <th>{{ "RRN" }}</th>
                <th>{{ "STAN" }}</th>
                <th>{{ "Reserve Amount" }}</th>
                <!-- <th>{{ "Amount" }}</th> -->
                <th>{{ "Balance Amount" }}</th>

                <th>{{ $tc("refund") }} {{ $t("Status") }}</th>
                <!-- <th>{{ $tc("refund") }} {{ $t("Approved By") }}</th> -->
                <th>{{ $tc("refund") }} {{ $t("Time") }}</th>
                <th>{{ "Logs" }}</th>
                <th>{{ "Action" }}</th>
              </tr>
            </thead>
            <tbody
              v-for="(data, userIndex) in reservationList"
              :key="userIndex"
              class="sph-report"
            >
              <tr>
                <td
                  :style="
                    data.booking_status == false && data.payment_status == true
                      ? 'color:red'
                      : data.booking_status == true &&
                        data.payment_status == true
                      ? 'color:green'
                      : ''
                  "
                >
                  {{ data.reservation_id | filterNullUndefined }}
                </td>
                <td>{{ data.cinema_name || "-" }}</td>
                <td class="text-left">{{ data.movie_title || "-" }}</td>
                <td>{{ data.customer_email_final || email_check || "-" }}</td>
                <td>{{ data.customer_mobile_final || mobile_check || "-" }}</td>
                <td>{{ data.bs_source || "-" }}</td>
                <td>{{ data.created_at | fulldatemonparse }}</td>
                <td>{{ data.actual_show_time | fulldatemonparse }}</td>
                <td>{{ data.sb_booking_code | filterNullUndefined }}</td>
                <td>{{ data.seat_name | filterNullUndefined }}</td>
                <td>{{ data.order_code | filterNullUndefined }}</td>
                <td>
                  {{ data.payment_type_actual_name | filterNullUndefined }}
                </td>
                <td>{{ data.payment_status_name | filterNullUndefined }}</td>
                <td>{{ data.booking_status_name | filterNullUndefined }}</td>

                <td>
                  {{
                    getSafe(
                      () => data.payment_transaction_detail.payment_option
                    ) ||
                    getSafe(
                      () =>
                        data.payment_transaction_detail.sourceOfFunds.provided
                          .card.brand
                    ) ||
                    getSafe(() => data.payment_transaction_detail.cardType) ||
                    "-"
                  }}
                </td>

                <td>
                  {{
                    getSafe(
                      () => data.payment_transaction_detail.card_number
                    ) ||
                    getSafe(
                      () =>
                        data.payment_transaction_detail.sourceOfFunds.provided
                          .card.number
                    ) ||
                    getSafe(() => data.payment_transaction_detail.card) ||
                    "-"
                  }}
                </td>

                <td>
                  {{
                    getSafe(
                      () => data.payment_transaction_detail.card_holder_name
                    ) ||
                    getSafe(
                      () =>
                        data.payment_transaction_detail.sourceOfFunds.provided
                          .card.nameOnCard
                    ) ||
                    "-"
                  }}
                </td>

                <td>
                  {{
                    getSafe(
                      () => data.payment_transaction_detail.authorization_code
                    ) ||
                    getSafe(
                      () =>
                        data.payment_transaction_detail.transaction[
                          data.payment_transaction_detail.transaction.length - 1
                        ].transaction.authorizationCode
                    ) ||
                    getSafe(() => data.payment_transaction_detail.authCode) ||
                    "-"
                  }}
                </td>

                <td>
                  {{
                    getSafe(() => data.payment_transaction_detail.fort_id) ||
                    getSafe(
                      () =>
                        data.payment_transaction_detail.transaction[
                          data.payment_transaction_detail.transaction.length - 1
                        ].transaction.receipt
                    ) ||
                    getSafe(() => data.payment_transaction_detail.ref) ||
                    "-"
                  }}
                </td>

                <td>
                  {{
                    getSafe(
                      () =>
                        data.payment_transaction_detail.transaction[
                          data.payment_transaction_detail.transaction.length - 1
                        ].authorizationResponse.stan
                    ) ||
                    getSafe(
                      () =>
                        data.payment_transaction_detail.transaction[
                          data.payment_transaction_detail.transaction.length - 1
                        ].transaction.stan
                    ) ||
                    "-"
                  }}
                </td>
                <td>
                  {{ currFormat(data.reserve_amount) }}
                </td>
                <!-- <td>
                  {{
                    data.srt_payment_type == "3" // 'Amazon PayFort'
                      ? currFormat(
                        parseFloat(data.payment_transaction_detail.amount) /
                        100
                      )
                      : data.srt_payment_type == "4" // 'Master/Visa'
                        ? currFormat(
                          parseFloat(data.payment_transaction_detail.amount)
                        )
                        : data.srt_payment_type == "5" // 'Al Raji
                          ? currFormat(
                            parseFloat(data.payment_transaction_detail.amt)
                          )
                          : data.srt_payment_type == "6" // 'Khalti E-Payment
                            ? currFormat(
                              parseFloat(data.payment_transaction_detail.amount)
                            )
                            : ""
                  }}
                </td> -->
                <td>
                  {{ currFormat(data.total_amount) }}
                </td>
                <td>
                  <span v-if="data.refund_date_time">
                    {{
                      data.total_amount > 0 ? "Partial Refunded" : "Refunded"
                    }}
                  </span>
                  <span></span>
                  <!-- <span v-if="data._refunded">
                    {{data.total_amount>0 ? "Partial Refunded" : "Refunded" }}
                  </span>
                  <span v-else>
                    {{ data.refund_status }}
                    {{ data.auto_refund_reason == "Y" ? "(Auto)" : "" }}
                  </span> -->
                </td>
                <!-- <td class="text-left">
                  {{
                    data.refund_approver_name
                      ? data.refund_approver_name
                      : data.refunded_user_name
                        ? data.refunded_user_name
                        : "-"
                  }}
                </td> -->
                <td class="text-left">
                  <div>
                    <span>{{ data.refund_date_time || "-" }}</span>
                  </div>
                </td>

                <td class="text-left">
                  <b-button
                    class="btn-blue v-step-1"
                    variant="default"
                    v-on:click="getSystemLogs(data)"
                  >
                    {{ "Get Logs" }}
                  </b-button>
                </td>
                <td class="text-left">
                  <div
                    v-if="data._refunded || filter_is_active_label == 'Pending'"
                  >
                    <span>{{ "" }}</span>
                  </div>

                  <!-- <b-button v-else-if="
                    data.booking_status_id == 3 ||
                    data.refund_status != 'Success'
                  " variant="default" v-on:click="processRefund(data)" class="btn-blue v-step-1">{{ $tc("refund")
                  }}</b-button> -->
                  <b-button
                    v-else-if="data.total_amount > 0"
                    variant="default"
                    v-on:click="processRefund(data)"
                    class="btn-blue v-step-1"
                    >{{ $tc("refund") }}</b-button
                  >
                </td>
              </tr>
            </tbody>
            <tbody v-if="reservationList.length == 0">
              <tr>
                <td colspan="13">
                  <!-- <p v-if="reservationList.length == 0" class="text-center">
                  {{ $tc("NoRecords") }}
                </p> -->
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div ref="onPrintRefund" class="d-none">
        <div v-html="EjsDataRefund"></div>
      </div>
      <b-pagination
        v-if="reservationList.length > 0"
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="rows"
        aria-controls="my-table"
        class="my-3"
        @change="onChangePagination($event)"
      ></b-pagination>
    </div>
    <ManagerAuthLogin
      :moduleName="'PGRefund'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_PGRefund'"
    />

    <b-modal
      ref="paymentDetailsModal"
      id="paymentDetailsModal"
      hide-footer
      no-close-on-esc
      :title-html="`<div class='d-flex align-items-center'><span class='lock'></span>&nbsp;<span>Payment Details</span></div>`"
      header-class="managerAuthPop__header_class"
      modal-class="managerAuthPop__modal_class"
      title-class="managerAuthPop__title_class"
      centered
      no-fade
      no-stacking
      no-enforce-focus
      no-close-on-backdrop
    >
      <div class="row mx-0">
        <div class="col mx-auto align-self-center">
          <div class>
            <div class="" style="background-color: #eeeeee">
              <pre style="color: #444; /*line-height: 1.7;*/">
            {{ " " }}
            {{ paymentDetailsObj }}
            {{ " " }}
          </pre
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import PosService from "@/services/PosService";
import PosFnbService from "@/services/PosFnbService.js";
import Printd from "printd";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { createQueryString } from "@/services/ApiHelper";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { BASEURL } from "@/config/index";
import { CLIENT_NAME } from "@/helper/Role";
import * as XLSX from "xlsx";

export default {
  name: "PaymentGatewayRefund",
  components: { DatePicker, Multiselect, NoRecords, ManagerAuthLogin },
  data() {
    return {
      paymentDetailsObj: {},
      EjsDataRefund: null,
      online_pm_details: {
        srt_payment_type: null,
      },
      // filter_is_active_label: "Payment Success | Booking Failed",
      filter_is_active_label: "Payment Success | Booking Success",
      loaderInstance: null,
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      selectedFilterValue: "",
      filterValues: [],
      filterValuesCopy: [],
      searchFilterValues: "",
      isRoleID: true,
      reservationList: [],
      reservationListCopy: [],
      searchUserValue: "",
      searchUsers: [],
      isSearchLoading: false,
      schedules: [],
      selected_ssid: "",
      selected_show_time: null,

      selectedFilter: "",
      users: ["Screen", "Movie", "User", "Show Booking Code"],
      // fromDate: new Date(new Date() - (7 * 86400000)),
      // toDate: new Date(),
      fetchReservationDetail: {
        date: "",
        cinema_id: "",
        ssb_code: "",
        show_date: "",
        show_date_to: null,
        // from_date: new Date(new Date() - 7 * 86400000),
        from_date: new Date(),
        to_date: new Date(),
      },
      filterkey: "",
      filtervalue: "",
      selectedCinema: "",
      selectedCinemaAddress: "",
      Cinemas: [],
      EjsData: null,
      perPage: 100,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      sendMailObj: [],
      currencyData: "",
      searchReservations: "",

      selectedBooking: null,
      noAuth: false,
      isPrivateShow: false,
      cc_customer_field_error: "",
      selectedCustomer: "",
      selected_cust_email: "",
      cashCardDetails: "",
      cardSaleType: 1, // 1 -> street sale AND 2 -> customer sale
      RefundReason: "",
      section: {
        one: true,
        two: false,
      },
      booking_id: "",
      order_code: "",
      refund: {
        sb_id: null,
        booking_id: null,
        enterRefundAmount: null,
        //
        booking_status_id: null,
        rr_reason: null,
        rr_id: null,
        payment_mode_id: null,
        //
        curr_code: null,
        sb_total_net_amount: null,
        sb_total_amount: null,
        sb_total_amount_paid: null,
        seat_amount_total: 0,
      },
      Refunds: [],
      seats: [],
      Selectedseats: [],
      selectedPayment: "",
      selectedPaymentObj: "",
      offer_name: "",
      offer_price: 0,
      voucher_name: "",
      seatsArray: [],
      cashCardsList: [],
      search_ccn: "",
      cc_input_error: "",
      customerList: [],
      AlreadyRefunded: [],
      OrderItems: [],
      BookingDetails: {
        pm_id: null,
        pm_payment_mode: "",
        bs_id: null,
        booking_source: "",
      },
    };
  },
  beforeMount() {
    this.getRefunds();
    this.fetchPaymentTypesList();

    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.getCurrencyCode();
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSelectCinema(null, CinemaObj);
    }

    console.log("transactions page route", this.$route);
    let queryparams = this.$route.query;

    if (queryparams.cinema_id && parseInt(queryparams.cinema_id)) {
      this.fetchReservationDetail.cinema_id = parseInt(queryparams.cinema_id);
    }

    this.getviewingnumber();
  },
  mounted() {
    if (CLIENT_NAME.STAR == this.CLIENT_SETUP_NAME) {
      console.log({
        "this.CLIENT_SETUP_NAME": this.CLIENT_SETUP_NAME,
      });

      let params = {
        path: "/cinema-manager/star-payment-gateway-refund",
      };

      this.$router.push(params);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(null, CinemaObj);
      }
    },
  },
  computed: {
    ...mapGetters(["getPaymentTypesList", "MANAGER_AUTH_FOR_CHANGES"]),
    checkPrintAvailable() {
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
    },
    checkValidation() {
      return !!(
        this.fetchReservationDetail.from_date &&
        this.fetchReservationDetail.to_date
      );
    },
  },
  methods: {
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchPaymentTypesList",
    ]),
    getSystemLogs(data) {
      this.paymentDetailsObj = {};
      let loader = this.$loading.show();

      MasterService.getPaymentFlowLogs(
        data.reservation_id,
        this.fetchReservationDetail.cinema_id
      )
        .then((res) => {
          if (!res.data.status) {
            return this.$toasted.show(
              res.data.message || "Something Went Wrong"
            );
          }

          this.paymentDetailsObj = {
            logs: res.data.logs,
          };
          this.$bvModal.show("paymentDetailsModal");
        })
        .finally(() => {
          loader.hide();
        });
    },
    onChangeFilterIsActive(option) {
      this.reservationList = [];
      this.reservationListCopy = [];

      this.filter_is_active_label = option;
      this.searchReservations = "";
      this.onSearchReservation();
    },
    getRefunds: function () {
      let body = {
        tableName: "ms_refund_reasons",
        rr_is_active: "Y",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.Refunds = data.Records;
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch((error) => {
          this.$toasted.show("Catch Error", error);
        });
    },
    onSearchReservation() {
      this.currentPage = 1;
      // this.onGetTransactionList();
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
            console.log(this.currencyData, " this.currencyData");
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    sendMailToUpdate() {},
    sendMailToUser(obj) {},
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, { sheet: "Refund_Alrajhi" });
      let loader = this.$loading.show();

      Object.keys(wb.Sheets.Refund_Alrajhi)
        .filter((_t) => _t.charAt(0) == "A")
        .map((z) => {
          wb.Sheets.Refund_Alrajhi[z].t = "s";
        });
      console.log(wb);
      loader.hide();
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || "Refund_Alrajhi." + (type || "xlsx"));
    },
    excelDownload(BASE_URL, type) {
      let payload = {
        cinema_id: this.fetchReservationDetail.cinema_id,
        from_date: this.fetchReservationDetail.from_date
          ? moment(this.fetchReservationDetail.from_date).format("YYYY-MM-DD")
          : null,
        filterkey: this.filterkey ? this.filterkey : null,
        filtervalue: this.filtervalue ? this.filtervalue : null,
        ss_id: this.selected_ssid || null,
        limit: 10000,
        currentPage: 1,
        type: type,
      };
      payload["to_date"] = this.fetchReservationDetail.to_date
        ? moment(this.fetchReservationDetail.to_date).format("YYYY-MM-DD")
        : null;

      console.log(payload);
      let qs = createQueryString(payload);
      console.log(qs);
      window.open(`${BASE_URL}/api/admin/reports/v2/transactions${qs}`);
    },
    moment,
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.onGetTransactionList();
      } else {
        this.currentPage = event;
        this.onGetTransactionList();
      }
    },
    onPrintHandler: function (sb_id, cinema_id) {
      let loader = this.$loading.show();
      let isReprint = true;
      PosService.GetTicketEjs(sb_id, cinema_id, isReprint)
        .then(async (response) => {
          const { data } = response;

          this.EjsData = data;

          this.$nextTick(() => {
            loader.hide();
            const p = new Printd();
            if (this.$refs.onPrint && this.EjsData != null) {
              p.print(this.$refs.onPrint, []);
            }
          });
        })
        .catch(this._CatchError);
    },
    clearDate(type = 1) {
      this.currentPage = 1;
      this.reservationList = [];

      switch (type) {
        case 2:
        case "to_date":
          this.fetchReservationDetail.from_date = "";
          this.fetchReservationDetail.to_date = "";
          break;
      }
    },
    onchangeDate: _.debounce(function (query) {
      this.reservationList = [];
      this.reservationListCopy = [];

      this.searchReservations = "";
      this.reservationList = [];
      this.currentPage = 1;
      // this.onGetTransactionList();
    }, 500),
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },

    getCinemaList: function (cine_id) {
      this.Cinemas = [];

      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.Cinemas = [...data.Records];
            // this.CinemasCopy = [...dataR, ...data.Records];
            this.CinemasCopy = [...data.Records];
            console.log(this.fetchReservationDetail, "fetchReservationDetail");
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.fetchReservationDetail.cinema_id = x.cine_id;
                // this.selectedCinema = x.cine_name;
                this.onSelectCinema(null, {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                });
              }

              if (
                this.fetchReservationDetail &&
                this.fetchReservationDetail.cinema_id &&
                x.cine_id === this.fetchReservationDetail.cinema_id
              ) {
                this.selectedCinema = x.cine_name;
                this.selectedCinemaAddress = x.cine_address;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    onGetTransactionList: function (isExcel) {
      if (!this.fetchReservationDetail.cinema_id) {
        return this.$toasted.show("Please select cinema");
      }
      if (
        (!this.fetchReservationDetail.to_date &&
          !this.fetchReservationDetail.from_date) ||
        (this.fetchReservationDetail.to_date &&
          !this.fetchReservationDetail.from_date) ||
        (!this.fetchReservationDetail.to_date &&
          this.fetchReservationDetail.from_date)
      ) {
        this.$toasted.show("Please select Reservation date range properly");
        return;
      }

      this.reservationList = [];
      if (this.fetchReservationDetail.cinema_id && this.checkValidation) {
        let loader = this.$loading.show();

        this.btenable = true;
        let payload = {
          excel: isExcel,
          reservation_payment_type: [3, 4, 5],
          cinema_name: this.selectedCinema || "",
          cinema_address: this.selectedCinemaAddress || "",
          cinema_id: this.fetchReservationDetail.cinema_id,
          from_date: this.fetchReservationDetail.from_date
            ? moment(this.fetchReservationDetail.from_date).format("YYYY-MM-DD")
            : null,
          to_date: this.fetchReservationDetail.to_date
            ? moment(this.fetchReservationDetail.to_date).format("YYYY-MM-DD")
            : null,
          // filterkey: this.filterkey ? this.filterkey : null,
          // filtervalue: this.filtervalue ? this.filtervalue : null,
          limit: isExcel == "N" ? this.perPage : this.rows,
          currentPage: this.currentPage,
        };
        console.log(payload, "dada");
        if (!!this.searchReservations)
          payload.search_val = this.searchReservations;
        if (!!this.filter_is_active_label) {
          payload.filter =
            this.filter_is_active_label == "Pending"
              ? "pending"
              : this.filter_is_active_label ==
                "Payment Success | Booking Success"
              ? "success"
              : this.filter_is_active_label ==
                "Payment Success | Booking Failed"
              ? "no_booking_with_payment"
              : "all";
        }

        MasterService.getReservationsDetailTemp(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data.status && data.Records && data.Records.length > 0) {
              this.reservationList = data.Records;
              this.reservationListCopy = data.Records;
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              this.reservationList.forEach((r) => {
                try {
                  if (typeof r.payment_transaction_detail === "string") {
                    r.payment_transaction_detail = JSON.parse(
                      r.payment_transaction_detail
                    );
                  } else if (
                    typeof r.payment_transaction_detail === "object" &&
                    r.payment_transaction_detail !== null
                  ) {
                  } else {
                    r.payment_transaction_detail = {};
                  }
                } catch (e) {
                  console.log(
                    "reservationList json parsing payment_transaction_detail error",
                    e
                  );
                  r.payment_transaction_detail = {};
                }
              });

              if (data.totalRows && data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue = this.perPage;
              } else if (data.totalRows) {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else if (data.Records && data.Records.length == 0) {
              this.rows = 0;
              this.selectedvalue = "0";
              this.$toasted.show("No Records Found.");
            } else {
              this.rows = 0;
              this.selectedvalue = "0";
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 100);
          });
      } else {
        this.$toasted.show("Invalid Selection");
      }
    },
    onSelectCinema: function (event, params) {
      this.reservationList = [];
      this.reservationListCopy = [];

      this.searchCinema = "";
      this.searchReservations = "";
      this.onSearchCinema(null);
      if (params.cine_id != "All") {
        this.$store.dispatch("selectDropdownCinema", params);
      }
      this.selectedCinema = params.cine_name;
      this.fetchReservationDetail.cinema_id = params.cine_id;
      // if (this.fetchReservationDetail.from_date) {
      //   this.onGetTransactionList();
      // } else {
      //   this.$toasted.show("Please select date");
      // }
    },
    onCheckAuthentication(response) {
      const { valid, name } = response;
      if (valid) {
        if (name == "PGRefund") {
          this.noAuth = true;
          this.$bvModal.hide("authManager_PGRefund");
          this.processRefund();
        }
      }
    },
    getCinemaTicketTemplate: function () {
      const { cinema_id } = this.BookingDetails;
      let body = {
        cine_id: cinema_id,
      };
      MasterService.TicketTemplateByCinemaID(body).then((response) => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.TemplateList = data.Records;
          }
        }
      });
    },
    getBookingInfoForTicket() {
      const { username } = this.secureStore.get("USINFO");
      let arabic_company_name = "";

      let arabic_company_name_data = JSON.parse(
        this.BookingDetails.cinema_translation_data
      ).filter((lang) => {
        return lang.langaugeId == 3;
      });

      if (
        arabic_company_name_data &&
        arabic_company_name_data.length > 0 &&
        arabic_company_name_data[0].hasOwnProperty("company_name")
      ) {
        arabic_company_name = arabic_company_name_data[0].company_name;
      }

      let tempObj = {
        template_id: this.TemplateList[0].template_id,
        pos_user_name: username,
        translationData: arabic_company_name,
        cine_name: this.BookingDetails.cinema_name,
        cine_address: this.BookingDetails.cinema_address,
        company_name: this.BookingDetails.company_name,
        vat_number: this.BookingDetails.vat_number,
        sb_id: this.BookingDetails.show_booking_id,
        sb_booking_code: this.BookingDetails.sb_booking_code,
        og_show_date: this.BookingDetails.t_show_date_full,
        og_show_time: this.BookingDetails.t_show_time,
        sb_booking_date: this.BookingDetails.sb_booking_date_time,
        sb_booking_time: this.BookingDetails.sb_booking_date_time,
      };

      return tempObj;
    },
    onPrintRefundHandler: async function (isReprint = false) {
      const { cinema_id } = this.BookingDetails;
      console.log("this.BookingDetails", this.BookingDetails);
      console.log(
        "this.BookingDetails.final_addon_gross_charges",
        this.BookingDetails.final_addon_gross_charges
      );
      let addOnsArr = [];
      let overallPrice = 0;
      let isRefund = true;
      this.BookingDetails.final_addon_gross_charges.map((x) => {
        if (x.length > 0) {
          x.forEach((y) => {
            if (y.is_additional_price_on_ticket == "N") {
              addOnsArr.push(y);
            }
          });
        }
      });
      console.log("addOnsArr", addOnsArr);
      var userAgent = navigator.userAgent.toLowerCase();
      console.log(this.TemplateList, "templateList");
      let bookingInfo = this.getBookingInfoForTicket();
      if (
        this.TemplateList &&
        this.TemplateList.length > 0 &&
        this.checkPrintAvailable
      ) {
        PosService.GetRefundTicketEjs(
          this.BookingDetails["show_booking_id"],
          cinema_id,
          isReprint
        )
          .then((response) => {
            if (response) {
              const { data } = response;
              this.EjsDataRefund = data;
              this.$nextTick(() => {
                const p = new Printd();
                if (this.$refs.onPrintRefund && this.EjsDataRefund != null) {
                  p.print(this.$refs.onPrintRefund, []);
                }
              });
            }
          })
          .then(() => {
            addOnsArr.map((z, index) => {
              overallPrice += z.final_price;
              setTimeout(() => {
                let payload = {
                  addOns: JSON.stringify(z),
                  bookingDetails: JSON.stringify(bookingInfo),
                  isReprint: false,
                  isRefund: isRefund,
                };
                PosService.GetAddonTicketEjs(payload).then(
                  async (s_response) => {
                    const { data } = s_response;

                    this.EjsDataRefund = data;

                    this.$nextTick(() => {
                      const p = new Printd();
                      if (
                        this.$refs.onPrintRefund &&
                        this.EjsDataRefund != null
                      ) {
                        p.print(this.$refs.onPrintRefund, []);
                      }
                    });
                  }
                );
              }, 2000);
            });
          })
          .then(() => {
            PosService.GetTicketSecurityEjs(
              this.BookingDetails["show_booking_id"],
              cinema_id,
              isReprint,
              addOnsArr,
              isRefund
            ).then(async (s_response) => {
              const { data } = s_response;

              this.EjsDataRefund = data;

              this.$nextTick(() => {
                const p = new Printd();
                if (this.$refs.onPrintRefund && this.EjsDataRefund != null) {
                  p.print(this.$refs.onPrintRefund, []);
                }
              });
            });
          })
          .then(() => {
            if (this.order_code) {
              let payload = {
                OrderCode: this.order_code,
                Type: "Print",
                UserID: user_id,
                isReprint: false,
                isRefund: true,
              };
              PosFnbService.GetFnbRefundEjs(payload)
                .then(async (response) => {
                  const { data } = response;
                  this.EjsDataRefund = data;
                  this.$nextTick(() => {
                    loader.hide();
                    const p = new Printd();
                    if (
                      this.$refs.onPrintRefund &&
                      this.EjsDataRefund != null
                    ) {
                      p.print(this.$refs.onPrintRefund, []);
                    }
                  });
                })
                .catch(this._CatchError);
            }
          })
          .catch(this._CatchError);
      } else {
        console.log("No template selected for Refund Invoice");
      }
    },
    onPrintOnlyFnbRefundHandler(isReprint = false) {
      if (this.order_code) {
        let payload = {
          OrderCode: this.order_code,
          Type: "Print",
          UserID: user_id,
          isReprint: false,
          isRefund: true,
        };
        PosFnbService.GetFnbRefundEjs(payload)
          .then(async (response) => {
            const { data } = response;
            this.EjsDataRefund = data;
            this.$nextTick(() => {
              loader.hide();
              const p = new Printd();
              if (this.$refs.onPrintRefund && this.EjsDataRefund != null) {
                p.print(this.$refs.onPrintRefund, []);
              }
            });
          })
          .catch(this._CatchError);
      }
    },
    processRefund: function (data) {
      if (
        !this.fetchReservationDetail.cinema_id ||
        this.fetchReservationDetail.cinema_id == "" ||
        this.fetchReservationDetail.cinema_id == "All" ||
        this.fetchReservationDetail.cinema_id == "all"
      ) {
        this.loaderInstance && this.loaderInstance.hide();
        this.$toasted.show("Please select cinema");
        return;
      }

      if (data) {
        this.selectedBooking = data;
        this.booking_id = data.sb_booking_code;
        this.order_code = data.order_code;
      }

      this.$forceUpdate();

      console.log("processRefund", {
        "data.order_code": this.order_code,
        "data.sb_booking_code": this.booking_id,
        "this.noAuth": this.noAuth,
      });

      if (this.booking_id == "") {
        return this.$toasted.show("Enter Booking ID");
      } else if (this.MANAGER_AUTH_FOR_CHANGES == "Y" && !this.noAuth) {
        this.$bvModal.show("authManager_PGRefund");
      } else {
        let payload = {
          booking_id: this.booking_id,
          order_code: this.order_code,
        };

        PosService.GetFnbOrderDetails({ ...payload })
          .then((response) => {
            const { data } = response;
            console.log("GetFnbOrderDetails", data);

            if (data && data.status) {
              this.OrderItems = data.Records.filter(
                (x) => x.refund_datetime == null && x.is_refund == "N"
              ).map((y) => {
                return { ...y, keyboardActive: false };
              });

              this.AlreadyRefunded = data.Records.filter(
                (x) => x.refund_datetime != null && x.is_refund == "Y"
              );
            }
          })
          .catch((err) => {
            return Promise.resolve();
          })
          .then(() => {
            return PosService.getRefundReason({
              ...payload,
              cinema_id: this.fetchReservationDetail.cinema_id,
            });
          })
          .then((result) => {
            const { data } = result;
            if (data && data.status && !data.needCinemaManagerLogin) {
              this.section.one = false;
              this.section.two = true;
              this.RefundReason = data.Records[0].rr_reason;
              this.seats = data.Records;
              this.Selectedseats = data.Records;
              this.seatsArr = [
                {
                  label: "All",
                  SeatsArray: data.Records,
                },
              ];
              this.Selectedseats = data.Records.filter((x) => {
                return x.sl_id;
              });
              this.getPaymentTypesList.map((x) => {
                if (x.pm_id == data.Records[0].payment_mode_id) {
                  this.selectedPayment = x.pm_payment_mode;
                }
              });
              this.refund = {
                booking_id: this.booking_id,
                ...this.refund,
                ...data.Records[0],
              };
            } else if (
              (!data.status && data.needCinemaManagerLogin) ||
              data.message == "No Such booking id found"
            ) {
              this.CheckLogin();
            } else {
              console.log("data", data);
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    },
    CheckLogin: function () {
      this.loaderInstance = this.$loading.show();

      let payload = {
        booking_id: this.booking_id,
        username: "",
        password: "",
        noCheck: true,
        cinema_id: this.fetchReservationDetail.cinema_id,
      };
      PosService.CheckCinemaManagerLogin(payload)
        .then((response) => {
          const { data } = response;
          this.username = "";
          this.password = "";
          if (data.status) {
            this.section.one = false;
            this.section.two = true;
            this.seats = data.Records;
            this.Selectedseats = data.Records;

            this.seatsArr = [
              {
                label: "All",
                SeatsArray: data.Records,
              },
            ];
            this.isPrivateShow =
              data.Records.length > 0 &&
              data.Records[0].mycinema_booking_type_id &&
              data.Records[0].mycinema_booking_type_id == 3
                ? true
                : false;
            let OfferDetails = data.offerDetails;
            this.offer_name = OfferDetails.offer_name;
            this.offer_price = OfferDetails.offer_price.toFixed(
              this.MIN_FRACTION_DIGITS
            );
            this.voucher_name = OfferDetails.voucher_name;
            this.BookingDetails = data.bookingDetails;
            this.BookingDetails["cinema_id"] = data.bookingDetails["cine_id"];
            if (
              data.bookingDetails.hasOwnProperty("onlinePaymentModeDetails")
            ) {
              this.online_pm_details =
                data.bookingDetails.onlinePaymentModeDetails || "";
            }
            this.refund = {
              booking_id: this.booking_id,
              ...this.refund,
              ...data.Records[0],
            };
            this.refund["curr_code"] =
              data.bookingDetails["currency_code"] || "";
            this.getCinemaTicketTemplate();
          } else {
          }
        })
        .finally(() => {
          this.updatePGRefundStatus();
        });
    },
    updateBrijRefundStatus: function () {
      console.log("CALLED updateBrijRefundStatus");
      let pm = this.refund.payment_mode_id
        ? this.getPaymentTypesList.filter(
            (x) => x.pm_id == this.refund.payment_mode_id
          )[0]
        : {
            pm_payment_mode:
              this.selectedBooking.srt_payment_type == "3" // 'Amazon PayFort'
                ? "Amazon PayFort"
                : this.selectedBooking.srt_payment_type == "4" // 'Master/Visa'
                ? "Master/Visa"
                : this.selectedBooking.srt_payment_type == "5" // 'Al Rajhi Bank'
                ? "Al Rajhi Bank"
                : this.selectedBooking.srt_payment_type == "6" // 'Khalti E-Payment'
                ? "Khalti E-Payment"
                : "",
          };

      this.selectedPayment = pm.pm_payment_mode;

      let rr =
        this.Refunds.filter(
          (x) => String(x.rr_reason).toLowerCase() == "payment failure"
        )[0] || this.Refunds[0];
      this.RefundReason = rr.rr_reason;
      this.refund.rr_id = rr.rr_id;

      this.refund.seat_amount_total = 0;

      this.Selectedseats.map((x) => {
        this.refund.seat_amount_total =
          parseFloat(this.refund.seat_amount_total) +
          parseFloat(x.t_gross_amount);
      });

      this.refund.seat_amount_total += parseFloat(
        this.refund.total_add_ons_charge
      );
      this.refund.seat_amount_total += parseFloat(
        this.refund.internet_handling_fee
      );
      this.refund.enterRefundAmount = this.refund.seat_amount_total.toFixed(
        this.MIN_FRACTION_DIGITS
      );

      // fnb stuff
      if (this.order_code) {
        let refundAmount = 0;
        this.OrderItems.forEach((x) => {
          x.refund_reason = rr.rr_reason;
          x.refund_payment_mode_id = this.refund.payment_mode_id; //to refund payment mode id
          x.is_refund = "Y";
          refundAmount = +parseFloat(x.refunded_amount) + refundAmount;
        });
      }

      console.log("LINE 1336", this.OrderItems);

      if (String(this.refund.booking_status_id) === "12") {
        console.log("Refund has been done");
        this.$toasted.show("Refund has been done");
      } else if (
        !pm ||
        !this.refund.enterRefundAmount ||
        this.refund.enterRefundAmount.length == 0
      ) {
        console.log("Please enter refund amount");
        this.$toasted.show("Please enter refund amount");
      } else if (!this.selectedPayment || this.selectedPayment.length == 0) {
        console.log("Please select payment mode");
        // this.$toasted.show("Please select payment mode");
        return;
      }
      // else if (!this.checkPaymentModeValidation()) {
      //   return;
      // }
      else {
        console.log("this.booking_id", this.booking_id);
        if (this.booking_id) {
          let ssb_ids = [];
          let sl_ids = [];
          this.Selectedseats.map((y) => {
            this.seats.map((x) => {
              if (x.sl_id == y.sl_id) {
                ssb_ids.push(y.ssb_id);
                sl_ids.push(y.sl_id);
              }
            });
          });
          let payload = {
            ...this.refund,
            ssb_id: ssb_ids,
            sl_id: sl_ids,
          };
          return PosService.updateRefundStatus(payload)
            .then((response) => {
              this.$store.dispatch("onSetAndSendLog", {
                action: ` Selected refund for :${this.booking_id} and refund amount to be given was : ${this.refund.enterRefundAmount} `,
                page_name: "Dashboard Refund",
                api_name: window.location.hash,
              });
              const { data } = response;
              if (data && data.status) {
                this.section.one = true;
                this.section.two = false;
              } else {
              }
            })
            .then(() => {
              if (this.order_code) {
                console.log({
                  "this.order_code": this.order_code,
                });

                let payload = {
                  fnbRefundList: this.OrderItems,
                  cinema_id: this.fetchReservationDetail.cinema_id,
                };

                console.log("COMING INSIDE FNB REFUND LINE 1393", payload);

                return PosService.fnbRefund(payload)
                  .then((response) => {
                    const { data } = response;
                    console.log("fnbRefund data", data);
                    if (data && data.status) {
                    } else {
                    }
                  })
                  .catch((err) => {
                    console.log("fnbRefund Error: ", err);
                  });
              }
            })
            .finally(() => {
              if (this.checkPrintAvailable) {
                this.onPrintRefundHandler();
              }
            });
        } else if (this.order_code && !this.booking_id) {
          console.log({
            "this.order_code": this.order_code,
          });

          let payload = {
            fnbRefundList: this.OrderItems,
            cinema_id: this.fetchReservationDetail.cinema_id,
          };

          console.log("COMING INSIDE FNB REFUND LINE 1393", payload);

          return PosService.fnbRefund(payload)
            .then((response) => {
              const { data } = response;
              console.log("fnbRefund data", data);
              if (data && data.status) {
                if (this.checkPrintAvailable) {
                  this.onPrintOnlyFnbRefundHandler();
                }
              }
            })
            .catch((err) => {
              console.log("fnbRefund Error: ", err);
            });
        }
      }
    },

    ResetData: function () {
      this.booking_id = "";
      this.refund = {
        sb_id: null,
        booking_id: null,
        enterRefundAmount: null,
        //
        booking_status_id: null,
        rr_reason: null,
        rr_id: null,
        payment_mode_id: null,
        //
        curr_code: null,
        sb_total_net_amount: null,
        sb_total_amount: null,
        sb_total_amount_paid: null,
      };
      this.seats = [];
      this.Selectedseats = [];
      this.cashCardsList = [];
      this.selected_cust_email = "";
      this.selectedCustomer = "";
      this.RefundReason = "";
      this.selectedPaymentObj = "";
    },

    updatePGRefundStatus() {
      let payload = {
        reservation_id: this.selectedBooking.reservation_id,
        cinema_id: this.fetchReservationDetail.cinema_id,
        currency: this.currencyData.curr_code,
        fort_id: this.selectedBooking.payment_transaction_detail.fort_id || "",
        sr_id: this.selectedBooking.sr_id || "",
        pm_payment_mode: "Amazon PayFort",
        amount:
          this.getSafe(() => this.selectedBooking["total_amount"]) ||
          this.getSafe(
            () => this.selectedBooking.payment_transaction_detail.amount
          ) ||
          this.getSafe(
            () => this.selectedBooking.payment_transaction_detail.amt
          ),
      };

      return PosService.PaymentGatewayRefundApi(payload)
        .then((resData) => {
          console.log({
            resData,
          });

          console.log("PG REFUND RES", resData);

          if (resData.data.status == true) {
            this.reservationList.forEach((reservation) => {
              if (reservation.sr_id == this.selectedBooking.sr_id) {
                reservation._refunded = true;
              }
            });
            this.$forceUpdate();
            this.$toasted.show(resData.data.message);
            return this.updateBrijRefundStatus();
          } else {
            this.$toasted.show(
              typeof resData.data.message == "string"
                ? resData.data.message
                : "Something Went Wrong!."
            );
            return Promise.reject();
          }
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.loaderInstance && this.loaderInstance.hide();
        });
    },
    alrajhiInquiryPayment: function (data) {
      this.paymentDetailsObj = {};

      if (
        !this.fetchReservationDetail.cinema_id ||
        this.fetchReservationDetail.cinema_id == "" ||
        this.fetchReservationDetail.cinema_id == "All" ||
        this.fetchReservationDetail.cinema_id == "all"
      ) {
        this.loaderInstance && this.loaderInstance.hide();
        this.$toasted.show("Please select cinema");
        return;
      }

      let loader = this.$loading.show();
      let selectedBooking = JSON.parse(JSON.stringify(data));

      let payload = {
        cinema_id: this.fetchReservationDetail.cinema_id,
        currency: this.currencyData.curr_code,

        reservation_id: selectedBooking.reservation_id,

        amount:
          this.getSafe(
            () => selectedBooking.payment_transaction_detail.amount
          ) ||
          this.getSafe(() => selectedBooking.payment_transaction_detail.amt),
      };

      return PosService.AlrajhiInquiryPayment(payload)
        .then((resData) => {
          let error = this.getSafe(() => resData.data.error, {});
          let trandata = this.getSafe(() => resData.data.trandata, {});
          this.paymentDetailsObj = Object.assign({}, error, { trandata });

          this.$bvModal.show("paymentDetailsModal");
        })
        .catch((error) => {
          console.log({ error });
          this.$toasted.show("Something went wrong");
        })
        .finally(() => {
          loader && loader.hide();
        });
    },
  },
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}

.overflow_custom {
  overflow-y: scroll;
  height: 600px;
}

.custom_sticky_header {
  position: sticky;
  top: -1px;
  /* background: #fff; */
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/PaymentGatewayRefund/PaymentGatewayRefund.vue